import React, { useEffect, useState } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Get_Api } from "../API_URL";


function Gallery() {
    
    const [IsUploading, setIsUploading] = useState(false);
    const [AllGallery, setAllGallery] = useState([]);

    const Get_All_Gallery = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllGalleryImages');
            setAllGallery(response?.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Gallery();
    }, []);

    const [selectedImage, setSelectedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);

    const openImage = (index) => {
        setSelectedImage(AllGallery[index]?.Image);
        setCurrentIndex(index);
    };

    const closeImage = () => {
        setSelectedImage(null);
        setCurrentIndex(null);
    };

    const prevImage = () => {
        if (currentIndex > 0) {
            setSelectedImage(AllGallery[currentIndex - 1]?.Image);
            setCurrentIndex(currentIndex - 1);
        }
    };

    const nextImage = () => {
        if (currentIndex < AllGallery.length - 1) {
            setSelectedImage(AllGallery[currentIndex + 1]?.Image);
            setCurrentIndex(currentIndex + 1);
        }
    };


    return (
        <div className="md:px-[135px] px-[20px]">
            <br />
            <div className="event-heading">
                <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
                    Gallery
                </h6>
            </div>
            {IsUploading && (
                <div className="loading-text">Loading...</div>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {AllGallery?.map((image, index) => (
                    <div
                        key={image?._id}
                        className="w-full h-[250px] overflow-hidden rounded-lg cursor-pointer"
                        onClick={() => openImage(index)}
                    >
                        <img
                            src={image?.Image}
                            alt={`Gallery ${image?._id}`}
                            className="w-full h-full object-cover"
                        />
                    </div>
                ))}
            </div>

            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
                    <button className="absolute top-5 right-5 text-white text-3xl" onClick={closeImage}>
                        <FaTimes />
                    </button>
                    <button className="absolute left-5 text-white text-3xl" onClick={prevImage} disabled={currentIndex === 0}>
                        <FaChevronLeft />
                    </button>
                    <img src={selectedImage} alt="Selected" className="max-w-[90%] max-h-[90%] rounded-lg" />
                    <button className="absolute right-5 text-white text-3xl" onClick={nextImage} disabled={currentIndex === AllGallery.length - 1}>
                        <FaChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
}

export default Gallery;
